"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Practice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetReconciliationInvoiceStatusEnum = exports.GetReconciliationInvoiceMethodEnum = exports.ReconciliationApi = void 0;
const runtime = __importStar(require("../runtime"));
const models_1 = require("../models");
/**
 *
 */
class ReconciliationApi extends runtime.BaseAPI {
    /**
     * Returns the paginated data from a reconciliation invoices
     * Get the reconciliation list
     */
    async getReconciliationRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling getReconciliation.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getReconciliation.');
        }
        if (requestParameters.limit === null || requestParameters.limit === undefined) {
            throw new runtime.RequiredError('limit', 'Required parameter requestParameters.limit was null or undefined when calling getReconciliation.');
        }
        const queryParameters = {};
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.approved !== undefined) {
            queryParameters['approved'] = requestParameters.approved;
        }
        if (requestParameters.needsAttention !== undefined) {
            queryParameters['needsAttention'] = requestParameters.needsAttention;
        }
        if (requestParameters.clientLabelId !== undefined) {
            queryParameters['clientLabelId'] = requestParameters.clientLabelId;
        }
        if (requestParameters.invoiceMethod !== undefined) {
            queryParameters['invoiceMethod'] = requestParameters.invoiceMethod;
        }
        if (requestParameters.cycleStart !== undefined) {
            queryParameters['cycleStart'] = requestParameters.cycleStart;
        }
        if (requestParameters.cycleEnd !== undefined) {
            queryParameters['cycleEnd'] = requestParameters.cycleEnd;
        }
        if (requestParameters.cursorInvoiceId !== undefined) {
            queryParameters['cursorInvoiceId'] = requestParameters.cursorInvoiceId;
        }
        if (requestParameters.cursorClientId !== undefined) {
            queryParameters['cursorClientId'] = requestParameters.cursorClientId;
        }
        if (requestParameters.invoiceStatus !== undefined) {
            queryParameters['invoiceStatus'] = requestParameters.invoiceStatus;
        }
        const headerParameters = {};
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/reconciliation`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GetReconciliation200ResponseFromJSON)(jsonValue));
    }
    /**
     * Returns the paginated data from a reconciliation invoices
     * Get the reconciliation list
     */
    async getReconciliation(requestParameters, initOverrides) {
        const response = await this.getReconciliationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Returns a of invoices that needs attention before approval
     * Get the invoices that needs attention
     */
    async getReconciliationAttentionNeededRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling getReconciliationAttentionNeeded.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getReconciliationAttentionNeeded.');
        }
        const queryParameters = {};
        if (requestParameters.cycleStart !== undefined) {
            queryParameters['cycleStart'] = requestParameters.cycleStart;
        }
        if (requestParameters.cycleEnd !== undefined) {
            queryParameters['cycleEnd'] = requestParameters.cycleEnd;
        }
        const headerParameters = {};
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/reconciliation/attention-needed`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.GetReconciliationAttentionNeeded200ResponseInnerFromJSON));
    }
    /**
     * Returns a of invoices that needs attention before approval
     * Get the invoices that needs attention
     */
    async getReconciliationAttentionNeeded(requestParameters, initOverrides) {
        const response = await this.getReconciliationAttentionNeededRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Returns a list of reconciliation cycles
     * Get the reconciliation cycles
     */
    async getReconciliationCyclesRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling getReconciliationCycles.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getReconciliationCycles.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/reconciliation/cycles`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.GetSessionBillingCycles200ResponseInnerFromJSON));
    }
    /**
     * Returns a list of reconciliation cycles
     * Get the reconciliation cycles
     */
    async getReconciliationCycles(requestParameters, initOverrides) {
        const response = await this.getReconciliationCyclesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Returns data with the total of items based on the lists
     * Get the reconciliation numbers
     */
    async getReconciliationNumbersRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling getReconciliationNumbers.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getReconciliationNumbers.');
        }
        const queryParameters = {};
        if (requestParameters.cycleStart !== undefined) {
            queryParameters['cycleStart'] = requestParameters.cycleStart;
        }
        if (requestParameters.cycleEnd !== undefined) {
            queryParameters['cycleEnd'] = requestParameters.cycleEnd;
        }
        const headerParameters = {};
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/reconciliation/numbers`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GetReconciliationNumbers200ResponseFromJSON)(jsonValue));
    }
    /**
     * Returns data with the total of items based on the lists
     * Get the reconciliation numbers
     */
    async getReconciliationNumbers(requestParameters, initOverrides) {
        const response = await this.getReconciliationNumbersRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Approve a invoices in batch
     */
    async postBatchApproveInvoicesRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling postBatchApproveInvoices.');
        }
        if (requestParameters.postBatchApproveInvoicesRequest === null || requestParameters.postBatchApproveInvoicesRequest === undefined) {
            throw new runtime.RequiredError('postBatchApproveInvoicesRequest', 'Required parameter requestParameters.postBatchApproveInvoicesRequest was null or undefined when calling postBatchApproveInvoices.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/reconciliation/batch-approve`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.PostBatchApproveInvoicesRequestToJSON)(requestParameters.postBatchApproveInvoicesRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Approve a invoices in batch
     */
    async postBatchApproveInvoices(requestParameters, initOverrides) {
        const response = await this.postBatchApproveInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
exports.ReconciliationApi = ReconciliationApi;
/**
  * @export
  * @enum {string}
  */
var GetReconciliationInvoiceMethodEnum;
(function (GetReconciliationInvoiceMethodEnum) {
    GetReconciliationInvoiceMethodEnum["Auto"] = "auto";
    GetReconciliationInvoiceMethodEnum["Manual"] = "manual";
})(GetReconciliationInvoiceMethodEnum || (exports.GetReconciliationInvoiceMethodEnum = GetReconciliationInvoiceMethodEnum = {}));
/**
  * @export
  * @enum {string}
  */
var GetReconciliationInvoiceStatusEnum;
(function (GetReconciliationInvoiceStatusEnum) {
    GetReconciliationInvoiceStatusEnum["Shared"] = "shared";
    GetReconciliationInvoiceStatusEnum["Failed"] = "failed";
    GetReconciliationInvoiceStatusEnum["Paid"] = "paid";
    GetReconciliationInvoiceStatusEnum["Scheduled"] = "scheduled";
    GetReconciliationInvoiceStatusEnum["Draft"] = "draft";
    GetReconciliationInvoiceStatusEnum["Open"] = "open";
})(GetReconciliationInvoiceStatusEnum || (exports.GetReconciliationInvoiceStatusEnum = GetReconciliationInvoiceStatusEnum = {}));
//# sourceMappingURL=ReconciliationApi.js.map